var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgLawyer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 360,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#img-lawyer_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9 173h47.2c3.259 0 5.9 2.906 5.9 6.491v25.773c0 3.585-2.641 6.492-5.9 6.492l-19.011-.001v9.908c0 .186-.137.337-.306.337a.29.29 0 01-.216-.099l-9.222-10.146-18.445.001c-3.258 0-5.9-2.907-5.9-6.492v-25.773c0-3.585 2.642-6.491 5.9-6.491z",
    fill: "#CDDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86 187a1 1 0 010 2H49a1 1 0 010-2h37zm-16 9a1 1 0 010 2H49a1 1 0 010-2h21z",
    fill: "#0248C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.116 166C285 166 337.798 210.788 347.87 271.849l13.403 81.205c4.19 19.829-10.932 38.49-31.204 38.49H118.905c-20.263 0-35.394-18.661-31.204-38.49l10.036-76.952C105.946 213.123 159.603 166 223.116 166z",
    fill: "#0044CA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M251.671 305.961h40.544L282.531 231H152.809v139.433h98.862v-64.472z",
    fill: "url(#img-lawyer_svg__paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.671 347.609l-29.82.516-6.85 7.195c-1.964 2.063-5.123 2.715-7.575 1.285a6.104 6.104 0 01-2.136-8.598l-3.711 3.901c-1.963 2.063-5.122 2.715-7.574 1.285a6.093 6.093 0 01-2.127-8.597l-1.068 1.122a6.1 6.1 0 01-9.412-.706c-1.72-2.398-1.294-5.738.742-7.874l.914-.959a6.105 6.105 0 01-8.697-1.71c-1.557-2.38-1.059-5.575.905-7.629l14.118-15.096a15.622 15.622 0 0111.394-4.959l50.915-.073v40.897h-.018z",
    fill: "#3385FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.303 334.27l12.326-12.951M193.054 342.596l12.326-12.951M206.476 346.026l7.656-8.046",
    stroke: "#000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.05 384.451h155.189V266.05c0-4.996-4.054-9.05-9.05-9.05H25.05c-4.996 0-9.05 4.054-9.05 9.05v109.351c0 4.996 4.054 9.05 9.05 9.05z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5 332.015c6.237 0 11.294-5.056 11.294-11.294s-5.057-11.294-11.294-11.294c-6.238 0-11.295 5.056-11.295 11.294s5.057 11.294 11.294 11.294zM93.82 307.589s1.385-7.828-8.443-8.543c0 0-.805 7.982 8.444 8.543z",
    fill: "#C9DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.512 301.984l29.91-135.524H188.33l29.91 135.524v1.23l.136-.615.136.615v-1.23z",
    fill: "#CDDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.449 166.641l-11.594 14.091s3.838 14.082 4.019 14.082H226.023c.181 0 4.019-14.082 4.019-14.082l-11.593-14.091zM225.842 197.185H211.19l-7.575 39.231 14.897 67.812 14.905-67.812-7.575-39.231z",
    fill: "#5E8EF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.145 166.469h-14.842l12.624 24.181c.924 1.774 3.503 1.774 4.435 0l12.625-24.181h-14.842zM232.838 166.469h-14.842l12.624 24.181c.923 1.774 3.503 1.774 4.435 0l12.625-24.181h-14.842z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.174 68.775h-67.255c7.714-10.264 18.957-17.71 31.946-20.528A54.33 54.33 0 01215.441 47c1.072 0 2.125.037 3.178.102 24.952 1.44 45.387 19.677 50.182 43.577.434 2.161.721 4.37.896 6.614-8.518-2.78-22.56-10.014-30.523-28.518z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.127 71.278a69.382 69.382 0 011.783-2.504h67.255c7.963 18.505 22.005 25.738 30.523 28.519.102 1.367.176 2.744.176 4.139 0 30.061-24.371 54.432-54.432 54.432-30.061 0-54.432-24.371-54.432-54.432.018-11.16 3.372-21.525 9.127-30.154z",
    fill: "#2D80FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.062 109.368c7.051 0 12.767-5.717 12.767-12.768 0-7.05-5.716-12.767-12.767-12.767-7.051 0-12.767 5.716-12.767 12.767 0 7.051 5.716 12.768 12.767 12.768z",
    fill: "#2D80FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.886 89.635a1.755 1.755 0 100-3.511 1.755 1.755 0 000 3.51zM223.58 89.635a1.755 1.755 0 100-3.511 1.755 1.755 0 000 3.51z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.452 101.718a5.445 5.445 0 01-3.862-1.598 5.448 5.448 0 01-1.598-3.862 5.448 5.448 0 012.125-4.323c1.986-1.534 3.335-3.76 3.335-6.273V81.22M215.884 110.43c-5.339 4.065-11.076 4.388-17.303 0",
    stroke: "#000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.1 99.935h-6.642c-5.534 0-10.023-4.49-10.023-10.023v-8.158h26.68v8.158c.009 5.533-4.481 10.023-10.015 10.023zM226.314 99.935h-6.642c-5.534 0-10.024-4.49-10.024-10.023v-8.158h26.681v8.158c.009 5.533-4.472 10.023-10.015 10.023z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.787 87.556s-1.801-1.93-6.956-1.93-6.956 1.93-6.956 1.93",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "img-lawyer_svg__paint0_linear",
    x1: 222.511,
    y1: 255.9,
    x2: 222.511,
    y2: 497.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "img-lawyer_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h360v360H0z"
  })))));
}
export default SvgImgLawyer;